import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnES: CultureInfo = {
  name: 'en-ES',
  displayName: 'English (Spain)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-ES',
  parent: CultureInfoEn
};
